import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _Asterisk;
var _excluded = ["avatarPlaceholderProps", "checked", "defaultIconId", "destructive", "disabled", "helpIcon", "hintCheckbox", "hintCheckboxProps", "hintText", "iconLeadingIcon", "iconType", "inputTooltipDescription", "inputTooltipLabel", "inputTooltipPlacement", "inputTooltipVariant", "inputWidth", "isSelectedIcon", "label", "labelTooltipDescription", "labelTooltipLabel", "labelTooltipPlacement", "labelTooltipVariant", "menuItems", "menuMaxHeight", "menuWidth", "onChange", "onChangeCheckbox", "placeholder", "placeholderIconId", "readOnly", "required", "size", "typeLeading", "value"];
/* eslint-disable max-lines */
import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Typography from '@mui/material/Typography';
import { styled, useTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import { Avatar } from '../Avatar';
import Box from '@mui/material/Box';
import { SHADOWS } from '@im/im-theme/constants';
import { Dot } from '../common/Dot';
import { Icon } from '../Icon';
import { CountryIcon } from '../CountryIcon';
import { PaymentIcon } from '../PaymentIcon';
import { Asterisk } from '../common/Astreisk';
import { getScrollbarStyles } from '../common/getScrollbarStyles';
import { Badge } from '../Badge';
import { MenuItem } from '../MenuItem';
import { HelpIconWithTooltip } from '../common';
import { Checkbox } from '../Checkbox';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var PrimaryTypography = styled(Typography)(function (_ref) {
  var theme = _ref.theme;
  return {
    color: theme.palette.gray[900],
    marginLeft: 8
  };
});
var SecondaryTypography = styled(Typography)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    color: theme.palette.gray[500],
    marginLeft: 8
  };
});
export var typeLeadingMap = {
  'Avatar Leading': 'avatarLeading',
  'Dot Leading': 'dotLeading',
  'Icon Leading': 'iconLeading'
};
export function InputDropdown(props) {
  var _Icon;
  var avatarPlaceholderProps = props.avatarPlaceholderProps,
    _props$checked = props.checked,
    checked = _props$checked === void 0 ? false : _props$checked,
    defaultIconId = props.defaultIconId,
    _props$destructive = props.destructive,
    destructive = _props$destructive === void 0 ? false : _props$destructive,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$helpIcon = props.helpIcon,
    helpIcon = _props$helpIcon === void 0 ? false : _props$helpIcon,
    _props$hintCheckbox = props.hintCheckbox,
    hintCheckbox = _props$hintCheckbox === void 0 ? false : _props$hintCheckbox,
    hintCheckboxProps = props.hintCheckboxProps,
    hintText = props.hintText,
    iconLeadingIcon = props.iconLeadingIcon,
    _props$iconType = props.iconType,
    iconType = _props$iconType === void 0 ? 'default' : _props$iconType,
    inputTooltipDescription = props.inputTooltipDescription,
    inputTooltipLabel = props.inputTooltipLabel,
    inputTooltipPlacement = props.inputTooltipPlacement,
    inputTooltipVariant = props.inputTooltipVariant,
    inputWidth = props.inputWidth,
    isSelectedIcon = props.isSelectedIcon,
    label = props.label,
    labelTooltipDescription = props.labelTooltipDescription,
    labelTooltipLabel = props.labelTooltipLabel,
    labelTooltipPlacement = props.labelTooltipPlacement,
    labelTooltipVariant = props.labelTooltipVariant,
    menuItems = props.menuItems,
    menuMaxHeight = props.menuMaxHeight,
    menuWidth = props.menuWidth,
    onChange = props.onChange,
    onChangeCheckbox = props.onChangeCheckbox,
    placeholder = props.placeholder,
    placeholderIconId = props.placeholderIconId,
    _props$readOnly = props.readOnly,
    readOnly = _props$readOnly === void 0 ? false : _props$readOnly,
    _props$required = props.required,
    required = _props$required === void 0 ? false : _props$required,
    _props$size = props.size,
    size = _props$size === void 0 ? 'md' : _props$size,
    typeLeading = props.typeLeading,
    _props$value = props.value,
    value = _props$value === void 0 ? '' : _props$value,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    selectOpen = _useState2[0],
    setSelectOpen = _useState2[1];
  var handleMenuItemClick = function handleMenuItemClick(e, value) {
    onChange(e, value);
  };
  var renderBodyMenuItem = function renderBodyMenuItem(menuItem, selected) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Stack, {
        alignItems: "center",
        direction: "row",
        spacing: 2,
        "data-element": "Stack",
        "data-source-file": "InputDropdown.tsx",
        children: [typeLeading === 'Dot Leading' && /*#__PURE__*/_jsx(Dot, {
          color: menuItem.disabled ? theme.palette.gray[200] : theme.palette.success[500]
        }), typeLeading === 'Avatar Leading' && /*#__PURE__*/_jsx(Avatar, _extends({
          size: "xs"
        }, menuItem.avatarProps)), typeLeading === 'Icon Leading' && /*#__PURE__*/_jsxs(_Fragment, {
          children: [menuItem.countryIconId && iconType === 'countryIcon' && /*#__PURE__*/_jsx(CountryIcon, {
            id: menuItem.countryIconId,
            size: 20
          }), menuItem.paymentIconId && iconType === 'paymentIcon' && /*#__PURE__*/_jsx(PaymentIcon, {
            id: menuItem.paymentIconId,
            size: 30
          }), menuItem.iconId && iconType === 'default' ? /*#__PURE__*/_jsx(Icon, {
            iconId: menuItem.iconId,
            size: 20
          }) : defaultIconId && iconType === 'default' && (_Icon || (_Icon = /*#__PURE__*/_jsx(Icon, {
            iconId: defaultIconId,
            size: 20
          })))]
        }), /*#__PURE__*/_jsx(PrimaryTypography, {
          variant: "text-md-regular",
          "data-element": "PrimaryTypography",
          "data-source-file": "InputDropdown.tsx",
          children: menuItem.label
        }), menuItem.secondaryText && /*#__PURE__*/_jsx(SecondaryTypography, {
          variant: "text-md-regular",
          children: menuItem.secondaryText
        }), menuItem.badgeProps && /*#__PURE__*/_jsx(Badge, _extends({}, menuItem.badgeProps, {
          disabled: disabled,
          size: "sm"
        }))]
      }), selected && /*#__PURE__*/_jsx(Icon, {
        className: "dropdown-menu-item-selected-icon",
        color: theme.palette.primary[600],
        iconId: "Check",
        size: 20
      })]
    });
  };
  var renderMenuItem = function renderMenuItem(menuItem) {
    var selected = value === menuItem.value && isSelectedIcon;
    return /*#__PURE__*/_jsx(MenuItem, {
      avatarProps: menuItem.avatarProps,
      badge: menuItem.badgeProps,
      countryIconId: menuItem.countryIconId,
      disabled: menuItem.disabled,
      icon: menuItem.iconId ? /*#__PURE__*/_jsx(Icon, {
        iconId: menuItem.iconId,
        size: 20
      }) : null,
      id: menuItem.value,
      onClick: function onClick(e) {
        return handleMenuItemClick(e, menuItem.value);
      },
      paymentIconId: menuItem.paymentIconId,
      selected: selected,
      supportingText: menuItem.secondaryText,
      sx: {
        backgroundColor: menuItem.disabled ? theme.palette.gray[50] : '',
        borderColor: menuItem.disabled ? theme.palette.gray[300] : '',
        color: menuItem.disabled ? theme.palette.gray[600] : ''
      },
      text: '',
      textLeadingType: typeLeading ? typeLeadingMap[typeLeading] : undefined,
      textNode: menuItem.label,
      value: menuItem.value,
      "data-element": "MenuItem",
      "data-component": "renderMenuItem",
      "data-source-file": "InputDropdown.tsx",
      children: renderBodyMenuItem(menuItem, selected)
    }, menuItem.value);
  };
  var renderHelpIconTooltip = function renderHelpIconTooltip() {
    if (disabled) {
      return /*#__PURE__*/_jsx(Icon, {
        iconId: "HelpCircle",
        size: 16,
        sx: {
          mr: 2
        }
      });
    }
    return /*#__PURE__*/_jsx(HelpIconWithTooltip, {
      sx: {
        mr: 2
      },
      tooltipDescription: labelTooltipDescription,
      tooltipLabel: labelTooltipLabel,
      tooltipPlacement: labelTooltipPlacement,
      tooltipVariant: labelTooltipVariant,
      "data-element": "HelpIconWithTooltip",
      "data-component": "renderHelpIconTooltip",
      "data-source-file": "InputDropdown.tsx"
    });
  };
  var placeholderBody = /*#__PURE__*/_jsx(Typography, {
    color: "inherit",
    children: placeholder
  });
  var renderPlaceholderBody = function renderPlaceholderBody() {
    switch (typeLeading) {
      case 'Dot Leading':
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Dot, {
            color: disabled ? theme.palette.gray[200] : theme.palette.success[500],
            sx: {
              mr: '8px'
            }
          }), placeholderBody]
        });
      case 'Avatar Leading':
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Avatar, _extends({
            size: "xs",
            sx: {
              mr: '8px'
            }
          }, avatarPlaceholderProps)), placeholderBody]
        });
      case 'Icon Leading':
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [placeholderIconId ? /*#__PURE__*/_jsx(Icon, {
            iconId: placeholderIconId,
            size: 20,
            sx: {
              mr: '8px'
            }
          }) : defaultIconId && /*#__PURE__*/_jsx(Icon, {
            iconId: defaultIconId,
            size: 20,
            sx: {
              mr: '8px'
            }
          }), placeholderBody]
        });
      default:
        return placeholder;
    }
  };
  var renderPlaceholderWrapper = function renderPlaceholderWrapper() {
    return /*#__PURE__*/_jsx(Box, {
      sx: {
        alignItems: 'center',
        display: 'flex',
        opacity: disabled ? 0.38 : 1
      },
      "data-element": "Box",
      "data-component": "renderPlaceholderWrapper",
      "data-source-file": "InputDropdown.tsx",
      children: renderPlaceholderBody()
    });
  };
  var selectProps = {
    MenuProps: _extends({
      PaperProps: {
        sx: _extends({
          '& .MuiMenu-list': {
            padding: 0
          }
        }, getScrollbarStyles(theme, theme.palette.common.white), {
          border: "1px solid ".concat(theme.palette.gray[200]),
          boxShadow: theme.shadows[SHADOWS.lg],
          marginTop: '4px',
          pb: 0.5,
          pl: 1.5,
          pr: 1.5,
          pt: 1.5
        }, menuWidth && {
          width: menuWidth
        })
      }
    }, menuMaxHeight !== undefined && {
      sx: {
        maxHeight: menuMaxHeight
      }
    }),
    displayEmpty: true,
    open: selectOpen,
    renderValue: renderPlaceholderWrapper
  };
  if (value) {
    delete selectProps.displayEmpty;
    delete selectProps.renderValue;
  }
  return /*#__PURE__*/_jsxs(Stack, {
    spacing: 1.5,
    "data-element": "Stack",
    "data-component": "InputDropdown",
    "data-source-file": "InputDropdown.tsx",
    children: [label && /*#__PURE__*/_jsxs(Stack, {
      alignItems: 'center',
      direction: "row",
      spacing: 1,
      children: [/*#__PURE__*/_jsx(Typography, {
        color: theme.palette.gray[700],
        variant: "text-sm-medium",
        children: label
      }), required && (_Asterisk || (_Asterisk = /*#__PURE__*/_jsx(Asterisk, {}))), (labelTooltipLabel || labelTooltipDescription) && /*#__PURE__*/_jsx(HelpIconWithTooltip, {
        tooltipDescription: labelTooltipDescription,
        tooltipLabel: labelTooltipLabel,
        tooltipPlacement: labelTooltipPlacement,
        tooltipVariant: labelTooltipVariant
      })]
    }), /*#__PURE__*/_jsx(TextField, _extends({
      InputProps: {
        endAdornment: /*#__PURE__*/_jsxs(InputAdornment, {
          position: "end",
          sx: {
            '&:hover': {
              cursor: 'pointer'
            }
          },
          children: [helpIcon && renderHelpIconTooltip(), /*#__PURE__*/_jsx(Icon, {
            color: theme.palette.gray[500],
            iconId: "ChevronDown",
            size: 20
          })]
        }),
        onClick: function onClick() {
          if (disabled || readOnly) return;
          setSelectOpen(!selectOpen);
        },
        readOnly: destructive || disabled ? false : readOnly,
        sx: {
          '& .MuiOutlinedInput-input': {
            '& .dropdown-menu-item-selected-icon': {
              display: 'none'
            },
            color: "".concat(theme.palette.gray[500], " !important")
          },
          '.MuiAvatar-root': {
            height: '22px',
            width: '22px'
          },
          cursor: readOnly ? 'default' : 'pointer'
        }
      },
      SelectProps: selectProps,
      disabled: disabled,
      error: destructive,
      helperText: !hintCheckbox && hintText,
      required: required,
      select: true,
      size: size,
      sx: {
        width: inputWidth != null ? inputWidth : '100%'
      },
      value: value
    }, otherProps, {
      "data-element": "TextField",
      "data-source-file": "InputDropdown.tsx",
      children: menuItems.map(function (option) {
        return renderMenuItem(option);
      })
    })), hintCheckbox && /*#__PURE__*/_jsxs(Stack, {
      alignItems: 'flex-start',
      direction: "row",
      children: [/*#__PURE__*/_jsx(Checkbox, _extends({
        checked: checked,
        onChange: onChangeCheckbox
      }, hintCheckboxProps, {
        disabled: disabled,
        readOnly: readOnly,
        size: "sm",
        sx: {
          marginRight: '8px !important',
          marginTop: '2px !important'
        }
      })), /*#__PURE__*/_jsx(Typography, {
        color: destructive ? theme.palette.error[600] : theme.palette.gray[600],
        variant: "text-sm-regular",
        children: hintText
      })]
    })]
  });
}